export const KIWISTRON_LOGO = `${process.env.PUBLIC_URL || ''}/kiwistron-logo.png`;
export const KIWISTRON_BRAND_NAME = 'kiwistron';
export const KIWISTRON_APP_NAME = 'taskmanagement';
